import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Input, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SelectTerritorialUnitsCode from "../../../../components/selects/SelectTerritorialUnitsCode";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterLogisticsCenter = (props: IProps) => {
  const { t } = useTranslation();
  const [selectedRegionId, setSelectedRegionId] = useState<number|null>(null);
  const [selectedAreaCode, setSelectedAreaCode] = useState<string|null>(null);

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ [8, 8] }>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label="Название организации"
			name={ props.formField.centerName }
		  >
			<Input placeholder="Введите название организации"/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('titles.territorial_unit_area') }
			name={ props.formField.regionId }
		  >
			<SelectTerritorialUnitsCode
			  parentId={ 1 }
			  onChange={ (value, option: any) => {
				setSelectedRegionId(Number(value));
				setSelectedAreaCode(null);
				props.form.setFieldsValue({
				  [props.formField.regionId]: value,
				  [props.formField.areaId]: null,
				  [props.formField.territorialUnitId]: null,
				});
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t('titles.territorialUnitDistricts') }
			name={ props.formField.areaId }
		  >
			<SelectTerritorialUnitsCode
			  type={ ['AREA', 'CITY_OF_REPUBLICAN_SIGNIFICANCE'] }
			  parentId={ selectedRegionId }
			  onChange={ (value, option: any) => {
				setSelectedAreaCode(option?.data?.code || null);
				props.form.setFieldsValue({
				  [props.formField.areaId]: value,
				  [props.formField.territorialUnitId]: null,
				});
			  } }
			/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 12 } md={ 6 } lg={ 4 }>
		  <Form.Item
			label={ t("titles.territorialUnitVillage") }
			name={ props.formField.territorialUnitId }
		  >
			<SelectTerritorialUnitsCode areaCode={ selectedAreaCode }/>
		  </Form.Item>
		</Col>
		<Col xs={ 24 } sm={ 24 } md={ 24 } lg={ 24 }>
		  <div style={ { marginTop: 4 } }>
			<Button
			  type="primary"
			  shape="default"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 8 } }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  );
};
